// The public site footer's link columns.
//
// Built from the same registry and host rules as the navbar, so the footer can never offer a
// page the navbar hides: on a partner host there is no partners page and no platform pricing,
// and a beta build mounts no /pricing.
//
// Privacy and terms appear in the Legal column only once those pages are ready to publish (see
// legalContent.js); until then App.jsx does not mount them either. Credits is always there.

import { LEGAL_PAGES_READY } from '../legal/legalContent.js'
import { FEATURES_PATH } from './features/registry.js'
import {
    getVisibleSegments,
    showsPlatformPricing
} from './segments/registry.js'

/**
 * @param {object} options
 * @param {boolean} options.isPartnerHost host resolved to a partner (brand.is_partner)
 * @param {boolean} options.isBeta        public routes disabled by beta mode
 * @param {string} [options.brandKey]     brand.brand_key, which picks the audience links
 * @param {boolean} [options.legalReady]  privacy and terms pages are published
 * @returns {{ title: string, links: { label: string, to: string }[] }[]}
 */
export function footerColumns({
    isPartnerHost,
    isBeta,
    brandKey,
    legalReady = LEGAL_PAGES_READY
}) {
    const product = [{ label: 'Features', to: FEATURES_PATH }]
    if (showsPlatformPricing(isPartnerHost) && !isBeta) {
        product.push({ label: 'Pricing', to: '/pricing' })
    }

    const columns = [
        { title: 'Product', links: product },
        {
            title: 'Who it’s for',
            links: getVisibleSegments(isPartnerHost, brandKey).map(
                (segment) => ({
                    label: segment.chooserTitle,
                    to: segment.path
                })
            )
        },
        {
            title: 'Get in touch',
            links: [
                { label: 'Book a demo', to: '/contact' },
                { label: 'Sign in', to: '/login' }
            ]
        }
    ]
    // Credits is always linked: it attributes the CC BY cartoon avatar artwork,
    // which is offered whatever the state of the privacy and terms pages.
    const legal = legalReady
        ? [
              { label: 'Privacy policy', to: '/privacy' },
              { label: 'Terms of service', to: '/terms' }
          ]
        : []
    legal.push({ label: 'Credits', to: '/credits' })
    columns.push({ title: 'Legal', links: legal })
    return columns
}
